import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss']
})
export class AlertModalComponent implements OnInit {
  @Input() HeaderText: string;
  @Input() MessageText: string;
  @Output() closeModalClick = new EventEmitter();

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  modalClose() {
    this.closeModalClick.emit();
  }
}
